import { render, staticRenderFns } from "./prview2.vue?vue&type=template&id=62159a79&scoped=true&"
import script from "./prview2.vue?vue&type=script&lang=js&"
export * from "./prview2.vue?vue&type=script&lang=js&"
import style0 from "./prview2.vue?vue&type=style&index=0&id=62159a79&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62159a79",
  null
  
)

export default component.exports